import React from 'react';
import { FooterPartnerIcon } from './FooterPartnerIcon';
import { LoaderOrangeRings } from '../../loaders/loaderOrangeRings/LoaderOrangeRings';
import { useFooterPartner } from '../store';

export const FooterPartnersList = ({ imgHeight, className }) => {
    const { data, status } = useFooterPartner();

    if (status === 'loading') {
        return <LoaderOrangeRings />;
    }

    if (!data) {
        return null;
    }

    return (
        <>
            {data.map(partner => (
                <FooterPartnerIcon
                    key={partner.alt}
                    src={partner.src}
                    alt={partner.alt}
                    link={partner.url}
                    imgHeight={imgHeight}
                    className={className}
                />
            ))}
        </>
    );
};
